import {
  combineReducers,
  configureStore,
} from "@reduxjs/toolkit";
import userSlice from "./reducers/userSlice";
import basketSlice from "./reducers/basketSlice";
import { useDispatch } from "react-redux";
// ...

// Create the root reducer separately so we can extract the RootState type
const rootReducer = combineReducers({
  users: userSlice,
  basket: basketSlice,
});

const store = configureStore({
  reducer: rootReducer,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export default store;
